var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.$store.state.healthyHabits.table.data).length > 0
    ? _c(
        "div",
        { staticClass: "my-1" },
        [
          _c(
            "div",
            {
              staticClass: "current-month-table",
              class: { "current-month-table-mobile": _vm.mobileVersion() }
            },
            [_vm._v(_vm._s(_vm.currentMonthName))]
          ),
          _vm._v(" "),
          _c("b-table", {
            directives: [
              {
                name: "sortable",
                rawName: "v-sortable",
                value: _vm.sortableOptions,
                expression: "sortableOptions"
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.left",
                value: _vm.tableSwipe,
                expression: "tableSwipe",
                arg: "swipe",
                modifiers: { left: true }
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.right",
                value: _vm.tableSwipe,
                expression: "tableSwipe",
                arg: "swipe",
                modifiers: { right: true }
              }
            ],
            key:
              "healthyHabitsTable-" + _vm.$store.state.healthyHabits.table.key,
            attrs: {
              id: _vm.id,
              "tbody-tr-attr": _vm.trAttributes,
              fields: _vm.$store.state.healthyHabits.table.data.fields,
              items: _vm.$store.state.healthyHabits.table.data.items,
              hover: "",
              "foot-clone": "",
              small: "",
              "show-empty": ""
            },
            on: {
              "row-clicked": _vm.rowClick,
              "row-hovered": _vm.rowHovered,
              "row-unhovered": _vm.rowUnhovered
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "empty",
                  fn: function() {
                    return [
                      !_vm.$store.state.healthyHabits.isReadOnlyView
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addNewHabit()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("firstNewHabit")))]
                          )
                        : _c("span")
                    ]
                  },
                  proxy: true
                },
                {
                  key: "head()",
                  fn: function(data) {
                    return [
                      data.column === "description"
                        ? _c("span", [
                            _c(
                              "div",
                              [
                                _c("b-icon-info-circle", {
                                  staticClass: "cursor-pointer mx-2",
                                  attrs: { variant: "primary", scale: "1.5" },
                                  on: {
                                    click: function($event) {
                                      _vm.showTableInfoModal = !_vm.showTableInfoModal
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.$store.state.healthyHabits.isReadOnlyView
                                  ? _c(
                                      "base-button",
                                      {
                                        staticClass:
                                          "btn-padding-reduced-table",
                                        on: {
                                          click: function($event) {
                                            return _vm.addNewHabit()
                                          }
                                        }
                                      },
                                      [
                                        _vm.tabletMobileVersion
                                          ? _c("b-icon-plus", {
                                              attrs: { scale: "1.3" }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.tabletMobileVersion
                                              ? ""
                                              : _vm.$t("newHabit")
                                          )
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        : data.column === "prevDates" &&
                          (!_vm.$store.state.healthyHabits.setting
                            .invertedCalendarDays
                            ? _vm.$store.state.healthyHabits.table.maxDate <
                              _vm.getCurrentDateUtc()
                            : true)
                        ? _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.getDataInInterval(
                                    _vm.$store.state.healthyHabits.setting
                                      .invertedCalendarDays
                                  )
                                }
                              }
                            },
                            [
                              _c("b-icon-caret-right", {
                                attrs: { scale: "1.5" }
                              })
                            ],
                            1
                          )
                        : data.column === "nextDates" &&
                          (_vm.$store.state.healthyHabits.setting
                            .invertedCalendarDays
                            ? _vm.$store.state.healthyHabits.table.maxDate <
                              _vm.getCurrentDateUtc()
                            : true)
                        ? _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.getDataInInterval(
                                    !_vm.$store.state.healthyHabits.setting
                                      .invertedCalendarDays
                                  )
                                }
                              }
                            },
                            [
                              _c("b-icon-caret-left", {
                                attrs: { scale: "1.5" }
                              })
                            ],
                            1
                          )
                        : data.column === "sliderSection1"
                        ? _c("span", [
                            _c(
                              "div",
                              { staticClass: "slider-top" },
                              [
                                _c("b-icon-caret-left", {
                                  staticClass: "slider-left-arrow",
                                  on: {
                                    click: function($event) {
                                      return _vm.sliderClick(0)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 1
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("currentStreak")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 2
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "6ch"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("totalWeekShort")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 3
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "4ch"
                                    }
                                  },
                                  [_vm._v("% " + _vm._s(_vm.$t("weekShort")))]
                                )
                              : _vm._e()
                          ])
                        : data.column === "sliderSection2"
                        ? _c("span", [
                            _c(
                              "div",
                              {
                                staticClass: "slider-top-center slider-center",
                                staticStyle: { "font-weight": "700" },
                                on: { click: _vm.showMoreSlider }
                              },
                              [_vm._v(_vm._s(_vm.$t("showMore")))]
                            ),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 1
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("bestStreak")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 2
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "5ch"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("totalMonth")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 3
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "4ch"
                                    }
                                  },
                                  [_vm._v("% " + _vm._s(_vm.$t("month")))]
                                )
                              : _vm._e()
                          ])
                        : data.column === "sliderSection3"
                        ? _c("span", [
                            _c(
                              "div",
                              { staticClass: "slider-top" },
                              [
                                _c("b-icon-caret-right", {
                                  staticClass: "slider-right-arrow",
                                  on: {
                                    click: function($event) {
                                      return _vm.sliderClick(1)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 1
                              ? _c("span", [_vm._v(_vm._s(_vm.$t("total")))])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 2
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "5ch"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("totalYear")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentSliderPosition === 3
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "max-width": "4ch"
                                    }
                                  },
                                  [_vm._v("% " + _vm._s(_vm.$t("year")))]
                                )
                              : _vm._e()
                          ])
                        : data.label
                        ? _c(
                            "span",
                            {
                              class: {
                                "current-date": _vm.isCurentDate(data.label)
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDateNameFieldFormatted(data.label)
                                  )
                                )
                              ]),
                              _c("br"),
                              _c(
                                "span",
                                {
                                  class: {
                                    "current-date": _vm.isCurentDate(data.label)
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getDateFieldFormatted(data.label)
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(description)",
                  fn: function(data) {
                    return [
                      _vm.$store.state.healthyHabits.isReadOnlyView
                        ? _c(
                            "div",
                            { attrs: { name: "description" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "table-description",
                                  style: { color: data.item.color },
                                  attrs: {
                                    name: data.field.key,
                                    title: data.item.description
                                  }
                                },
                                [_vm._v(_vm._s(data.item.description))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-progress",
                                { attrs: { max: data.item.goal } },
                                [
                                  _c("b-progress-bar", {
                                    style: {
                                      "background-color": data.item.color
                                    },
                                    attrs: {
                                      value: data.item.accumulatedGoal,
                                      "label-html": _vm.getProgressLabel(data)
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { attrs: { name: "description" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "table-description",
                                  style: { color: data.item.color },
                                  attrs: {
                                    title: data.item.description,
                                    name: data.field.key
                                  }
                                },
                                [_vm._v(_vm._s(data.item.description))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4", lg: "1" } },
                                    [
                                      data.item.stored
                                        ? _c("b-icon-save", {
                                            staticClass:
                                              "description-icon-width"
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4", lg: "1" } },
                                    [
                                      data.item.goalCompleted
                                        ? _c("b-icon-trophy-fill", {
                                            staticClass:
                                              "description-icon-width",
                                            style: { color: data.item.color }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-progress",
                                { attrs: { max: data.item.goal } },
                                [
                                  _c("b-progress-bar", {
                                    style: {
                                      "background-color": data.item.color
                                    },
                                    attrs: {
                                      value: data.item.accumulatedGoal,
                                      "label-html": _vm.getProgressLabel(data)
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ]
                  }
                },
                {
                  key: "cell(nextDates)",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                },
                {
                  key: "cell(prevDates)",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                },
                {
                  key: "cell(sliderSection1)",
                  fn: function(data) {
                    return [
                      _vm.currentSliderPosition === 1
                        ? _c(
                            "div",
                            {
                              class: _vm.getSliderCircleClass(data.item, 1),
                              style: {
                                color:
                                  data.item.currentStreak > 0
                                    ? data.item.color
                                    : _vm.grayColour
                              },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(data.item.currentStreak))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 2
                        ? _c(
                            "div",
                            {
                              class: _vm.$uiHelpers.isMobileBrowser
                                ? "cell-overflow-fixed-mobile"
                                : "cell-overflow-fixed",
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getTotalCountWeek(data.item)))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 3
                        ? _c(
                            "div",
                            {
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTotalCountWeek(data.item, true)
                                  ) + "%"
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(sliderSection2)",
                  fn: function(data) {
                    return [
                      _vm.currentSliderPosition === 1
                        ? _c(
                            "div",
                            {
                              class: _vm.getSliderCircleClass(data.item, 2),
                              style: {
                                color:
                                  data.item.bestStreak > 0
                                    ? data.item.color
                                    : _vm.grayColour
                              },
                              attrs: { name: "slider" }
                            },
                            [_c("span", [_vm._v(_vm._s(data.item.bestStreak))])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 2
                        ? _c(
                            "div",
                            {
                              class: _vm.$uiHelpers.isMobileBrowser
                                ? "cell-overflow-fixed-mobile"
                                : "cell-overflow-fixed",
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getTotalCountMonth(data.item))
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 3
                        ? _c(
                            "div",
                            {
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTotalCountMonth(data.item, true)
                                  ) + "%"
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(sliderSection3)",
                  fn: function(data) {
                    return [
                      _vm.currentSliderPosition === 1
                        ? _c(
                            "div",
                            {
                              style: {
                                color:
                                  data.item.total > 0
                                    ? data.item.color
                                    : _vm.grayColour,
                                "padding-top": _vm.getSliderTotalPaddingTop(
                                  data.item
                                )
                              },
                              attrs: { name: "slider" }
                            },
                            [_c("span", [_vm._v(_vm._s(data.item.total))])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 2
                        ? _c(
                            "div",
                            {
                              class: _vm.$uiHelpers.isMobileBrowser
                                ? "cell-overflow-fixed-mobile"
                                : "cell-overflow-fixed",
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getTotalCountYear(data.item)))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSliderPosition === 3
                        ? _c(
                            "div",
                            {
                              style: { color: data.item.color },
                              attrs: { name: "slider" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTotalCountYear(data.item, true)
                                  ) + "%"
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(actions)",
                  fn: function(data) {
                    return [
                      !_vm.$store.state.healthyHabits.isReadOnlyView
                        ? _c(
                            "div",
                            { attrs: { name: "description" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("b-icon-pencil-square", {
                                        staticClass:
                                          "cursor-pointer blue description-icon-width",
                                        attrs: {
                                          scale: _vm.descriptionIconScale
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.editHabit(data.item.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("b-icon-bar-chart-fill", {
                                        staticClass:
                                          "cursor-pointer gray description-icon-width",
                                        attrs: {
                                          scale: _vm.descriptionIconScale
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$router.push({
                                              name: "healthyHabitsStatistics",
                                              params: { id: data.item.id }
                                            })
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      !data.item.stored
                                        ? _c("b-icon-trash", {
                                            staticClass:
                                              "cursor-pointer red description-icon-width",
                                            attrs: {
                                              scale: _vm.descriptionIconScale
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.itemId = data.item.id
                                                _vm.showConfirmDelete = true
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.item.stored
                                        ? _c("b-icon-arrow-clockwise", {
                                            staticClass:
                                              "cursor-pointer black description-icon-width",
                                            attrs: {
                                              scale: _vm.descriptionIconScale
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.itemId = data.item.id
                                                _vm.unStoreHabit()
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "foot(sliderSection1)",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        [
                          _c("b-icon-caret-left", {
                            staticClass: "slider-left-arrow",
                            on: {
                              click: function($event) {
                                return _vm.sliderClick(0)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "foot(sliderSection2)",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "slider-center",
                          on: { click: _vm.showMoreSlider }
                        },
                        [_vm._v(_vm._s(_vm.$t("showMore")))]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "foot(sliderSection3)",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        [
                          _c("b-icon-caret-right", {
                            staticClass: "slider-right-arrow",
                            on: {
                              click: function($event) {
                                return _vm.sliderClick(1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "foot()",
                  fn: function() {
                    return [_c("span")]
                  },
                  proxy: true
                },
                {
                  key: "cell()",
                  fn: function(data) {
                    return [
                      data.item.isMultiUser
                        ? _c(
                            "div",
                            {
                              staticClass: "multiUserCell",
                              class: {
                                "background-current-day": _vm.isCurentDate(
                                  data.field.key
                                )
                              }
                            },
                            [
                              _c("span", { staticClass: "cursor-pointer" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "letter-multiuser multi-user-initials",
                                    class: _vm.getMultiUserClass(
                                      _vm.$store.state.healthyHabits.setting
                                        .habitUserId,
                                      data.field.key,
                                      data
                                    ),
                                    style: _vm.getMultiUserStyle(
                                      _vm.$store.state.healthyHabits.setting
                                        .habitUserId,
                                      data.field.key,
                                      data
                                    ),
                                    attrs: { name: data.field.key }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.state.healthyHabits.setting
                                          .nick
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(data.item.multiUserInfo, function(item) {
                                return _c(
                                  "span",
                                  {
                                    key:
                                      item.healthyHabitsUserId +
                                      "-" +
                                      data.field.key,
                                    staticClass: "cursor-pointer"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "letter-multiuser multi-user-initials",
                                        class: _vm.getMultiUserClass(
                                          item.healthyHabitsUserId,
                                          data.field.key,
                                          data
                                        ),
                                        style: _vm.getMultiUserStyle(
                                          item.healthyHabitsUserId,
                                          data.field.key,
                                          data
                                        ),
                                        attrs: {
                                          id:
                                            data.item.id +
                                            "-" +
                                            item.healthyHabitsUserId +
                                            "-" +
                                            data.field.key,
                                          name: data.field.key
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.showMultiUserInfo(
                                              item.healthyHabitsUserId,
                                              data.field.key,
                                              item.nick,
                                              data
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(item.nick))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-popover",
                                      {
                                        attrs: {
                                          target:
                                            data.item.id +
                                            "-" +
                                            item.healthyHabitsUserId +
                                            "-" +
                                            data.field.key,
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.popoverMultiUserInfo.nick
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.popoverMultiUserInfo.state
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : data.item.measurable
                        ? _c(
                            "div",
                            {
                              staticClass: "data-color",
                              class: {
                                "cursor-pointer": !_vm.$store.state
                                  .healthyHabits.isReadOnlyView,
                                "cell-overflow-fixed": !_vm.$uiHelpers
                                  .isMobileBrowser,
                                "cell-overflow-fixed-mobile":
                                  _vm.$uiHelpers.isMobileBrowser,
                                "partial-fill-opacity":
                                  data.value < data.item.goal &&
                                  _vm.fillTableMeasurablePartialGoalCompleted(
                                    data
                                  ),
                                "background-current-day": _vm.isCurentDate(
                                  data.field.key
                                )
                              },
                              style: {
                                color: _vm.fillTableMeasurablePartialGoalCompleted(
                                  data
                                )
                                  ? data.item.color
                                  : _vm.grayColour
                              },
                              attrs: { name: data.field.key }
                            },
                            [
                              _c("span", { attrs: { name: data.field.key } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.value || 0) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { attrs: { name: data.field.key } }, [
                                _vm._v(_vm._s(data.item.measureUnit))
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              class: {
                                "cursor-pointer": !_vm.$store.state
                                  .healthyHabits.isReadOnlyView,
                                "background-current-day": _vm.isCurentDate(
                                  data.field.key
                                )
                              },
                              attrs: { name: data.field.key }
                            },
                            [
                              data.value === true
                                ? _c("b-icon-check-lg", {
                                    attrs: {
                                      color: data.item.color,
                                      name: data.field.key
                                    }
                                  })
                                : data.item[data.field.key] === -1
                                ? _c("b-icon-check-lg", {
                                    class: {
                                      "cursor-pointer": !_vm.$store.state
                                        .healthyHabits.isReadOnlyView,
                                      "partial-fill-opacity": true
                                    },
                                    attrs: {
                                      color: data.item.color,
                                      name: data.field.key
                                    }
                                  })
                                : data.item[data.field.key] === null
                                ? _c("b-icon-dash", {
                                    attrs: {
                                      scale: "2",
                                      color: data.item.color,
                                      name: data.field.key
                                    }
                                  })
                                : _c("b-icon-x-lg", {
                                    style: { color: _vm.grayColour },
                                    attrs: { name: data.field.key }
                                  })
                            ],
                            1
                          )
                    ]
                  }
                }
              ],
              null,
              false,
              4244023895
            )
          }),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                value: _vm.showTableInfoModal,
                title: _vm.$t("tableInfoTitle")
              },
              on: {
                hide: function($event) {
                  _vm.showTableInfoModal = false
                }
              }
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("tableInfo8")) + " "),
                _c(
                  "a",
                  {
                    attrs: { href: "/" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.$store.state.healthyHabits.showTableLegendModal = true
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("tableInfo8-2")))]
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo2")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo3")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo6")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo4")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("tableInfo7")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("tableInfo8-1")) + " "),
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$router.push({ name: "healthyHabitsFaqs" })
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("tableInfo8-2")))]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                width25: "",
                title: _vm.$t("whatWantToDo"),
                value: _vm.showConfirmDelete
              },
              on: {
                hide: function($event) {
                  _vm.showConfirmDelete = false
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-1",
                      on: {
                        click: function($event) {
                          return _vm.removeHabit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("remove")))]
                  ),
                  _c(
                    "base-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.storeHabit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("store")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82793f1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82793f1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-habits/HealthyHabitsTable.vue
// module id = 4177
// module chunks = 2